/** Parse MUI typography fontSize (rem/px/number) to pixels. */
export function parseFontSizePx(fontSize, htmlFontSize = 16) {
  if (fontSize == null) return htmlFontSize * 0.8125;
  if (typeof fontSize === 'number') return fontSize;
  const s = String(fontSize);
  if (s.endsWith('rem')) return parseFloat(s) * htmlFontSize;
  if (s.endsWith('em')) return parseFloat(s) * htmlFontSize;
  if (s.endsWith('px')) return parseFloat(s);
  const n = parseFloat(s);
  return Number.isNaN(n) ? htmlFontSize * 0.8125 : n;
}

/** Icon height vs adjacent text (em) — used by CurrencyAmount. */
export const DIRHAM_ICON_HEIGHT_EM = 0.72;

/** Icon height vs adjacent text (px ratio) — used by DirhamSymbol / inputs. */
export const DIRHAM_ICON_PX_RATIO = 0.78;

/** Shared sx for standalone DirhamSymbol next to text. */
export function dirhamSymbolEmSx(scale = 1) {
  const h = DIRHAM_ICON_HEIGHT_EM * scale;
  return {
    height: `${h}em`,
    width: 'auto',
    maxWidth: `${h * 1.15}em`,
    verticalAlign: '-0.06em'
  };
}

/** Icon height in px from typography variant. */
export function getDirhamSymbolSizePx(variant, theme, overridePx) {
  if (overridePx != null && overridePx !== '') return Number(overridePx);
  const key = !variant || variant === 'inherit' ? 'body2' : variant;
  const typo = theme.typography[key] || theme.typography.body2;
  const html = theme.typography.htmlFontSize ?? 16;
  const fontPx = parseFontSizePx(typo?.fontSize, html);
  return Math.max(9, Math.round(fontPx * DIRHAM_ICON_PX_RATIO));
}

/** Format numeric amount without currency symbol (use with CurrencyAmount). */
export function formatMoneyValue(n, options = {}) {
  if (n == null || n === '') return '—';
  const num = Number(n);
  if (Number.isNaN(num)) return '—';
  const minDec = options.decimals != null ? options.decimals : (options.minDecimals ?? 0);
  const maxDec = options.decimals != null ? options.decimals : (options.maxDecimals ?? 2);
  return num.toLocaleString('en-AE', {
    minimumFractionDigits: minDec,
    maximumFractionDigits: maxDec
  });
}

/** @deprecated Prefer CurrencyAmount for UI; returns amount digits only. */
export function formatMoney(n) {
  return formatMoneyValue(n);
}
export const CURRENCY_FALLBACKS = {
  AED: 'Ð',
  INR: '₹',
  USD: '$',
  EUR: '€',
  GBP: '£'
};

export const formatCurrency = (amount, currencyCode, currencySymbol) => {
  const code = currencyCode || currencySymbol || 'AED';
  let symbol = currencySymbol || code;

  if (CURRENCY_FALLBACKS[code]) {
    symbol = CURRENCY_FALLBACKS[code];
  } else if (CURRENCY_FALLBACKS[symbol]) {
    symbol = CURRENCY_FALLBACKS[symbol];
  }

  return `${symbol} ${Number(amount || 0).toFixed(2)}`;
};
